<template>
  <div class="preview-page">
    <h1>Please verify that the below screenshots have saved correctly. The close button is at the bottom of this screen.</h1>
    
    <img v-for="image in images" v-bind:src="image" />
    
    <p>You are currently viewing the uploaded saved screenshots. This is to ensure saving has been successful and that your internet remained stable throughout the save. This means if there are errors you need to manually delete the screenshots after closing the preview.</p>
    
    <p>If the screenshot has problems, please contact support.</p>
    
    <a href="https://www.google.com/" class="btn btn-primary" target="_top">Close Preview</a>
  </div>
</template>

<script>
  import WebLLCRESTApi from "../api/api";
  
  export default {
    async created() {
      const api = new WebLLCRESTApi("Search-Results", this.$router);
      const idList = this.$route.params.ids.split(",");
      
      const imagePromises = idList.map(async (id) => {
        const res = await api.remoteMethod(id + "/image");
        const blob = await res.blob();
        
        return URL.createObjectURL(blob);
      });
      
      this.images = await Promise.all(imagePromises);
    },
    
    destroy() {
      for(const imageURL of images) {
        URL.revokeObjectURL(imageURL);
      }
    },
    
    data() {
      return {
        images: []
      };
    },
    
    props: {
      
    },
    
    methods: {
      
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/PreviewScreenshots.vue